import { Dialog, DialogTitle, DialogContent } from '@mui/material'
import { EarnestMoneyTaskPayloadCheckForm } from './EarnestMoneyTaskPayloadCheckForm'

export function EarnestMoneyTaskPayloadDialog({ clientToken, onClose, onProcessed, onError }: {
  clientToken: string | null,
  onClose: () => void,
  onProcessed: (event: any) => void,
  onError: (event: any) => void,
}) {
  return (
    <Dialog open={!!clientToken} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Submit Check Payment</DialogTitle>
      <DialogContent>
        {clientToken && (
          <EarnestMoneyTaskPayloadCheckForm
            clientToken={clientToken}
            onProcessed={onProcessed}
            onError={onError}
            onCancel={onClose}
          />
        )}
      </DialogContent>
    </Dialog>
  )
}
